import {connect} from 'react-redux';
import UserManagmentComponent from '../../Components/Backend/userManagment';
import {getUserById, userStateChange, userAttributeChange} from '../../redux/actions/UserManagementActions';
import {withRouter} from 'react-router';

const UserManagementContainer = connect(
    (state) => { //map state to props
        return {
            userMgt: state.userManagementReducer
        };
    },

    (dispatch) => {
        return {
            getUserById: (id) => {
                dispatch(getUserById(id));
            },
            userStateChange: (id, option) => {
                dispatch(userStateChange(id, option));
            },
            userAttributeChange: (id, attList) => {
                dispatch(userAttributeChange(id, attList));
            }
        };

    }
)(UserManagmentComponent);

export default withRouter(UserManagementContainer);